<app-loading-spinner [loadingHintTranslationKey]="loadingHintTranslationKey" />
